'use client';
import { FC } from 'react';
import { usePathname } from 'next/navigation';
import PartnerhubLayout from '@/layouts/PartnethubLayout';
import NotFound from '../../../public/images/page-not-found-404.svg';
import Link from 'next/link';
import OpenAccessLayout from '@/layouts/OpenAccessLayout';
import { TypeMegaMenuComponentWithoutUnresolvableLinksResponse } from '@/features/contentful/_generated';
import { TEntriesResponse } from '@/features/contentful/types/types';
import { getLocalizedLink } from '@/utils/getLocalizedLink';

interface Props {
    partnerhubMenu?: TEntriesResponse<TypeMegaMenuComponentWithoutUnresolvableLinksResponse[]>;
    defaultMenu: TEntriesResponse<TypeMegaMenuComponentWithoutUnresolvableLinksResponse[]>;
    isAuthenticated: boolean;
    footerData: TypeMegaMenuComponentWithoutUnresolvableLinksResponse;
}

const CustomError: FC<Props> = ({ partnerhubMenu, defaultMenu, isAuthenticated, footerData }) => {
    const pathname = usePathname();
    const isPartnerHub = pathname?.includes('clienthub');

    if (!isAuthenticated) {
        return (
            <OpenAccessLayout megaMenu={defaultMenu} footerData={footerData}>
                <div id="main-container" className="tw-grow tw-content-center">
                    <section>
                        <div className="container c-description-button text-center wd50">
                            <NotFound className="error-page d-inline-block" />
                            <h1>Sorry, we can&apos;t find the page you&apos;re looking for</h1>
                            <Link className="btn btn-primary" href={getLocalizedLink('/')}>
                                Back to Homepage
                            </Link>
                        </div>
                    </section>
                </div>
            </OpenAccessLayout>
        );
    }

    const Layout = isPartnerHub ? PartnerhubLayout : OpenAccessLayout;
    const megaMenu = isPartnerHub ? partnerhubMenu : defaultMenu;
    const backLink = isPartnerHub ? getLocalizedLink('/clienthub') : getLocalizedLink('/');
    const backText = isPartnerHub ? 'Clienthub' : 'Homepage';

    return (
        <Layout megaMenu={megaMenu!} footerData={footerData}>
            <div id="main-container" className="tw-grow tw-content-center">
                <section>
                    <div className="container c-description-button text-center wd50">
                        <NotFound className="error-page d-inline-block" />
                        <h1>Sorry, we can&apos;t find the page you&apos;re looking for</h1>
                        <Link className="btn btn-primary" href={backLink}>
                            Back to {backText}
                        </Link>
                    </div>
                </section>
            </div>
        </Layout>
    );
};

export default CustomError;
